/**
* 左边菜单
*/
<template>
  <el-menu
    :collapse="collapsed"
    collapse-transition
    router
    :default-active="$route.path"
    unique-opened
    class="el-menu-vertical-demo side-menu"
    background-color="transparent"
    text-color="#dcd6ff"
    active-text-color="#ffffff">
    <div class="logobox">
      <div class="logo-mark">知</div>
      <div class="logo-text" v-show="!collapsed">知行悦房旅</div>
    </div>
    <el-menu-item
      v-for="item in menus"
      :key="item.url"
      :index="item.url"
      :class="'tone-' + item.tone">
      <i :class="item.icon"></i>
      <span slot="title">{{ item.name }}</span>
    </el-menu-item>
  </el-menu>
</template>
<script>
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      menus: [
        { name: '数据看板', url: '/home/dashboard', icon: 'el-icon-tickets', tone: 'violet' },
        { name: '租赁房源', url: '/housing/rent', icon: 'el-icon-menu', tone: 'mint' },
        { name: '买卖房源', url: '/housing/sale', icon: 'el-icon-goods', tone: 'sun' },
        { name: '预约看房', url: '/housing/visit', icon: 'el-icon-date', tone: 'sky' },
        { name: '卖房意向', url: '/housing/intent', icon: 'el-icon-edit', tone: 'coral' },
        { name: '买房意向', url: '/housing/buyIntent', icon: 'el-icon-search', tone: 'pink' },
        { name: '论坛帖子', url: '/housing/forum', icon: 'el-icon-message', tone: 'lime' },
        { name: '开通城市', url: '/housing/city', icon: 'el-icon-location', tone: 'sky' },
        { name: '用户管理', url: '/system/user', icon: 'el-icon-user', tone: 'violet' },
        { name: '账号信息', url: '/system/information', icon: 'el-icon-setting', tone: 'sky' }
      ]
    }
  },
  created() {
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 228px;
  min-height: 400px;
  border: none;
  text-align: left;
}
.el-menu {
  border: none;
}
.side-menu {
  background: transparent !important;
  padding: 0 8px 16px;
}
.side-menu .el-menu-item {
  height: 46px;
  line-height: 46px;
  margin: 4px 0;
  border-radius: 12px;
}
.side-menu .el-menu-item i {
  color: inherit;
  margin-right: 6px;
}
.side-menu .el-menu-item:hover {
  background: rgba(255, 255, 255, 0.08) !important;
}
.side-menu .el-menu-item.is-active {
  background: linear-gradient(135deg, #5b67f1, #8b5cf6) !important;
  box-shadow: 0 8px 18px rgba(91, 103, 241, 0.35);
  font-weight: 600;
}
.side-menu .tone-mint.is-active { background: linear-gradient(135deg, #14b8a6, #22d3ee) !important; box-shadow: 0 8px 18px rgba(20, 184, 166, 0.35); }
.side-menu .tone-sun.is-active { background: linear-gradient(135deg, #f59e0b, #fb7185) !important; box-shadow: 0 8px 18px rgba(245, 158, 11, 0.35); }
.side-menu .tone-sky.is-active { background: linear-gradient(135deg, #38bdf8, #6366f1) !important; box-shadow: 0 8px 18px rgba(56, 189, 248, 0.35); }
.side-menu .tone-coral.is-active { background: linear-gradient(135deg, #ff6b6b, #f43f5e) !important; box-shadow: 0 8px 18px rgba(255, 107, 107, 0.35); }
.side-menu .tone-pink.is-active { background: linear-gradient(135deg, #ec4899, #8b5cf6) !important; box-shadow: 0 8px 18px rgba(236, 72, 153, 0.35); }
.side-menu .tone-lime.is-active { background: linear-gradient(135deg, #84cc16, #14b8a6) !important; box-shadow: 0 8px 18px rgba(132, 204, 22, 0.35); }
.logobox {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 10px;
  margin-bottom: 8px;
}
.logo-mark {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 800;
  background: linear-gradient(135deg, #ff6b6b, #f59e0b 55%, #8b5cf6);
  margin-right: 10px;
  flex-shrink: 0;
}
.logo-text {
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

@media (orientation: landscape) and (max-height: 540px) {
  .logobox {
    height: 52px;
    margin-bottom: 4px;
  }
  .side-menu {
    padding-bottom: 8px;
    overflow-y: auto;
    height: calc(100vh - 52px);
  }
  .side-menu .el-menu-item {
    height: 38px;
    line-height: 38px;
    margin: 2px 0;
  }
}

@media (orientation: landscape) and (min-width: 768px) and (max-width: 1366px) {
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 196px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue